<template>
	<a-modal width="55%" title="对接列表" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-table :columns="columns" :data-source="form.connectArr" bordered :pagination="false" />
	</a-modal>
</template>
<script>
import { formMixin } from "@/mixins";

const columns = [
	{
		title: '姓名',
		dataIndex: 'senderContact',
	},
	{
		title: '手机号',
		dataIndex: 'senderContactNumber',
	},
];
export default {
	name: "DetailModal",

	mixins: [formMixin],
	data() {
		return {
			columns,
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less">
.pingguInfo {
	-webkit-box-flex: 1;
	-ms-flex: auto;
	flex: auto;
	overflow: hidden;
	color: rgba(0, 0, 0, 0.85);
	font-weight: bold;
	font-size: 16px;
	line-height: 1.5715;
	white-space: nowrap;
	text-overflow: ellipsis;
	margin-bottom: 15px;
}
</style>
